import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ok-fill",
  "use": "icon-icon-ok-fill-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-icon-ok-fill\"><path class=\"cls-1\" d=\"M98,17.8C51.7,17.8,14.2,54.6,14.2,100s37.5,82.2,83.8,82.2,83.8-36.8,83.8-82.2S144.3,17.8,98,17.8ZM146.1,78.7l-54.2,53.2h0c-2.5,2.5-6.3,2.8-9.2,1.2-.5-.3-1-.7-1.5-1.1,0,0,0,0,0,0l-31.2-30.6c-3-2.9-3-7.6,0-10.5,3-2.9,7.8-2.9,10.7,0l25.9,25.4,48.9-47.9c3-2.9,7.8-2.9,10.7,0,3,2.9,3,7.6,0,10.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol